
      // reduxForm fix :-/
      window.module = import.meta;
      window.module.hot = import.meta.hot; // need to be called to be set
      // react-joyride fix :-{
      window.global = window;

      (function () {
        var basePath = import.meta.env.PROD ? location.pathname.split("/")[1] : undefined;
        var base = document.createElement("base");
        base.setAttribute("href", basePath ? "/" + basePath + "/" : "/");
        document.head.insertBefore(base, document.head.firstElementChild);
      })();
    